import React from "react"
import { PrismicRichText } from "@prismicio/react"
import htmlSerializer from "../../utils/htmlSerializer"

const ContentSection = ({ slice }) => {
  return (
    <div className="blog-details w-full">
      <PrismicRichText
        field={slice.primary.section_content.richText}
        components={htmlSerializer}
      />
    </div>
  )
}

export default ContentSection